var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50005 0.299988C1.28502 0.299988 0.300049 1.28496 0.300049 2.49999V4.69999C0.300049 5.91501 1.28502 6.89999 2.50005 6.89999H4.70005C5.91508 6.89999 6.90005 5.91501 6.90005 4.69999V2.49999C6.90005 1.28496 5.91508 0.299988 4.70005 0.299988H2.50005Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50005 9.09999C1.28502 9.09999 0.300049 10.085 0.300049 11.3V13.5C0.300049 14.715 1.28502 15.7 2.50005 15.7H4.70005C5.91508 15.7 6.90005 14.715 6.90005 13.5V11.3C6.90005 10.085 5.91508 9.09999 4.70005 9.09999H2.50005Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10005 2.49999C9.10005 1.28496 10.085 0.299988 11.3 0.299988H13.5C14.7151 0.299988 15.7 1.28496 15.7 2.49999V4.69999C15.7 5.91501 14.7151 6.89999 13.5 6.89999H11.3C10.085 6.89999 9.10005 5.91501 9.10005 4.69999V2.49999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10005 11.3C9.10005 10.085 10.085 9.09999 11.3 9.09999H13.5C14.7151 9.09999 15.7 10.085 15.7 11.3V13.5C15.7 14.715 14.7151 15.7 13.5 15.7H11.3C10.085 15.7 9.10005 14.715 9.10005 13.5V11.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.3f2ffca313072a1d1a19730f7204d352.svg";
export { ForwardRef as ReactComponent };